var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('standard-navigation', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.$store.state.utils.isSplashModalOpen,
      expression: "!$store.state.utils.isSplashModalOpen"
    }],
    staticClass: "standard-navigation-custom",
    attrs: {
      "initialActiveItemId": "shirt_body",
      "leafIconContent": "icon-circle.svg",
      "closedGroupIconContent": "icon-plus.svg",
      "openGroupIconContent": "icon-minus.svg",
      "multipleSameLevelNodesOpened": false
    },
    on: {
      "tree-item-activated": _vm.onTreeItemActivated
    }
  }), !_vm.zoomLevelHigh ? _c('standard-arrow-navigation') : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }